document.addEventListener("DOMContentLoaded", function () {
  const emailLabel = document.querySelector('label[for="interest-email"]');
  const priceContainer = document.getElementById("price-container");
  const wrapper = document.getElementById("group-buy-interest-form-wrapper");

  if (!wrapper || !priceContainer) {
    console.warn("⚠️ Required DOM elements not found.");
    return;
  }

  const shop = wrapper.getAttribute("data-shop");
  const productId = wrapper.getAttribute("data-product-id");

  if (!shop || !productId) {
    console.warn("⚠️ Missing shop or product ID.");
    return;
  }

  const params = new URLSearchParams({
    subpath: "drop-info",
    shop: shop,
    product_id: productId,
  });

  fetch(`/apps/interest?${params.toString()}`)
    .then((res) => (res.ok ? res.json() : Promise.reject(res)))
    .then((data) => {
      if (data.interest_enabled && data.preorder_price) {
        // ✅ Update label
        if (emailLabel) {
          emailLabel.innerHTML = `Get notified if this becomes a group buy for <strong>$${parseFloat(
            data.preorder_price
          ).toFixed(2)}</strong>:`;

          const existingGroupPrice = document.getElementById("group-price");
          if (!existingGroupPrice) {
            const badge = document.createElement("div");
            badge.id = "group-price";
            badge.innerHTML = `
      <div style="margin-top:8px;">
        <span style="
          display: inline-block;
          background-color: #ffe5e5;
          color: #b80000;
          font-weight: bold;
          padding: 6px 10px;
          border-radius: 4px;
          font-size: 16px;
        ">
          🎉 Group Buy Price: $${parseFloat(data.preorder_price).toFixed(2)}
        </span>
      </div>`;
            priceContainer.appendChild(badge);
          } else {
            const groupPrice = document.getElementById("group-price");
            if (groupPrice) groupPrice.remove();
          }
        } else {
          console.log("ℹ️ Group buy teaser disabled by backend.");
        }
      } else {
        console.log("ℹ️ Group-buy not active or no price found.");
      }
    })
    .catch((err) => {
      console.error("❌ Failed to fetch drop info:", err);
    });
});
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("group-buy-interest-form-wrapper");
  if (!wrapper) return;

  const productId = wrapper.dataset.productId;
  const shop = wrapper.dataset.shop;

  fetch(`/apps/interest?subpath=drop-info&product_id=${productId}&shop=${shop}`)
    .then((res) => res.json())
    .then((data) => {
      if (data.active) {
        const formHTML = `
     <div id="groupbuy-interest-container" style="
  position: relative;
  max-width: 320px;
  background: #fefefe;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  font-family: sans-serif;
  font-size: 14px;
  border: 1px solid #ddd;
">
  <button onclick="document.getElementById('groupbuy-interest-container').style.display='none'" style="
    position: absolute;
    top: 6px;
    right: 8px;
    border: none;
    background: none;
    font-size: 16px;
    cursor: pointer;
    color: #888;
  " aria-label="Close form">&times;</button>

  <div style="text-align: center; font-size: 1.2em;">🌸🌼🌺</div>
  <h4 
  style="margin: 0 0 8px 0; font-size: 1.1em; color: #333; text-align: center;"
  title="Join the interest list to be notified when a group-buy discount becomes available.">
  Group Buy Alert
</h4>

  <form id="groupbuy-interest-form" style="display: flex; flex-direction: column; gap: 10px;">
    <label for="interest-email" style="font-weight: 500;">Email</label>
    <input
      type="email"
      id="interest-email"
      name="email"
      placeholder="you@example.com"
      required
      style="padding: 8px; font-size: 14px; border: 1px solid #ccc; border-radius: 5px;"
    >

    <button type="submit" style="
      background-color: #2a9d8f;
      color: white;
      border: none;
      padding: 8px;
      font-size: 14px;
      border-radius: 5px;
      cursor: pointer;
    ">Notify Me</button>
  </form>

  <div id="interest-success" style="display: none; color: green; font-weight: bold; text-align: center; font-size: 13px;">
    ✅ You’re on the list!
  </div>
</div>




        `;
        wrapper.innerHTML = formHTML;
      } else {
        wrapper.remove(); // 💡 Hides the form if not enabled
      }
    })
    .catch(console.error);
});
